




































import { Vue, Component } from "vue-property-decorator";
import { namespace } from "vuex-class";
import UserModel from "@/model/User";
import PageNavUser from "@/components/Elements/PageNavUser.vue";
import PageNavAdmin from "@/components/Elements/PageNavAdmin.vue";

const UserStore = namespace("User");
const AppStore = namespace("App");

@Component({
  name: "PageHeader",
  components: {
    PageNavAdmin,
    PageNavUser
  }
})
export default class PageHeader extends Vue {
  @UserStore.State public user!: UserModel;
  @AppStore.Getter public isAdminMode!: boolean;

  get pageNav(): string {
    return this.isAdminMode ? "PageNavAdmin" : "PageNavUser";
  }
}
